import * as React from 'react';
import { VtxButton, VtxIcon, VtxModal } from '@vertexinc/vtx-ui-react-component-library';
import Logging from '../Logging/Logging';
import CustomerApproveConfirmationProps from './CustomerApproveConfirmationProps.interface';
import './customer-approve-confirmation.scss';

const bodyStyle = {
  backgroundColor: 'white',
};

const CustomerApproveConfirmation = ({
  isOpen,
  onCancel,
  onApprove,
}: CustomerApproveConfirmationProps): JSX.Element => {
  const onCloseDialog = (): void => {
    Logging.Info('Loading: Close');
    onCancel();
  };

  return (
    <div>
      <VtxModal
        visible={isOpen}
        onCancel={(): void => onCloseDialog()}
        width="385px"
        bodyStyle={bodyStyle}
        footer={null}
        closable={false}
      >
        <div className="approveContainer">
          <div className="approveHeading">
            Are you sure you want to approve This Customer?
          </div>
          <div className="approveMessage">
            Approving a child Customer will also approve Any parent customer associated with this customer.
          </div>
          <div className="approveButtons">
            <div className="buttonItemBase">
              <VtxButton
                id="cancelButton"
                onClick={onCancel}
                type="default"
              >
                Cancel
              </VtxButton>
            </div>
            <div className="buttonItemBase">
              <VtxButton
                id="approveButton"
                icon={<VtxIcon type="check-circle" />}
                onClick={onApprove}
                type="primary"
                className="greenButton"
              >
                Approve
              </VtxButton>
            </div>
          </div>
        </div>
      </VtxModal>
    </div>
  );
};

export default CustomerApproveConfirmation;
